import React from 'react';

export const ClearRichContent = () => {
  const baseImageUrl =
    'https://static.lenskart.com/owndays/img/contact-lens-pdp/rich-content/clear';

  return (
    <div className="contact-lens-rich-content__wrapper">
      <div className="contact-lens-rich-content__header__container">
        <h1 className="contact-lens-rich-content__header__logo">
          <span>OWNDAYS | CLEAR</span>
          <img alt="OWNDAYS | CLEAR" src={`${baseImageUrl}/logo.svg`} />
        </h1>

        <div>
          <h2 className="contact-lens-rich-content__header__title">
            The new norm,
            <br />
            Finding joy in your eyewear
          </h2>

          <p className="contact-lens-rich-content__header__description">
            A collection that is impeccably tasteful, featuring frames in sleek silhouettes with
            delicate accents.
          </p>
        </div>
      </div>

      <div className="contact-lens-rich-content__main-preview">
        <picture>
          <source media="(min-width: 1200px)" srcSet={`${baseImageUrl}/main-preview_pc.webp`} />
          <img alt="OWNDAYS | CLEAR" src={`${baseImageUrl}/main-preview_sp.webp`} />
        </picture>

        <div>
          <div className="contact-lens-rich-content__main-preview__product">
            <div className="contact-lens-rich-content__main-preview__product__title">
              <div>
                <h3>UV Shield</h3>
                <p>
                  99% UV blocking,
                  <br />
                  crystal‑clear view
                </p>
              </div>
            </div>

            <picture>
              <source media="(min-width: 1200px)" srcSet={`${baseImageUrl}/product-1_pc.webp`} />
              <img alt="OWNDAYS | CLEAR" src={`${baseImageUrl}/product-1_sp.webp`} />
            </picture>
          </div>

          <div className="contact-lens-rich-content__main-preview__product" data-is-reverse="true">
            <div className="contact-lens-rich-content__main-preview__product__title">
              <div>
                <h3>HydraTouch</h3>
                <p>
                  Hyaluronic acid
                  <br />
                  for all day comfort
                </p>
              </div>
            </div>

            <picture>
              <source media="(min-width: 1200px)" srcSet={`${baseImageUrl}/product-2_pc.webp`} />
              <img alt="OWNDAYS | CLEAR" src={`${baseImageUrl}/product-2_sp.webp`} />
            </picture>
          </div>
        </div>
      </div>

      <div className="contact-lens-rich-content__main-preview">
        <picture>
          <source media="(min-width: 1200px)" srcSet={`${baseImageUrl}/main-product_pc.webp`} />
          <img alt="OWNDAYS | CLEAR" src={`${baseImageUrl}/main-product_sp.webp`} />
        </picture>

        <div>
          <div className="contact-lens-rich-content__main-preview__product">
            <div className="contact-lens-rich-content__main-preview__product__title">
              <div>
                <h3>AquaFlow</h3>
                <p>
                  58% water for
                  <br />
                  superior oxygen flow
                </p>
              </div>
            </div>

            <picture>
              <source media="(min-width: 1200px)" srcSet={`${baseImageUrl}/product-3_pc.webp`} />
              <img alt="OWNDAYS | CLEAR" src={`${baseImageUrl}/product-3_sp.webp`} />
            </picture>
          </div>

          <div className="contact-lens-rich-content__main-preview__product" data-is-reverse="true">
            <div className="contact-lens-rich-content__main-preview__product__title">
              <div>
                <h3>FeatherThin</h3>
                <p>
                  Precision thin profile for
                  <br />
                  effortless wear
                </p>
              </div>
            </div>

            <picture>
              <source media="(min-width: 1200px)" srcSet={`${baseImageUrl}/product-4_pc.webp`} />
              <img alt="OWNDAYS | CLEAR" src={`${baseImageUrl}/product-4_sp.webp`} />
            </picture>
          </div>
        </div>
      </div>

      <div className="contact-lens-rich-content__perfect-fit__container">
        <h3 className="contact-lens-rich-content__perfect-fit__title">FIND YOUR PERFECT FIT</h3>
        <p className="contact-lens-rich-content__perfect-fit__description">
          See how our lens compare
        </p>

        <ul className="contact-lens-rich-content__perfect-fit__images">
          <li>
            <img alt="Clear Vision Blue" src={`${baseImageUrl}/perfect-fit-1.webp`} />
            <h4>
              Clear
              <br />
              Vision Blue
            </h4>
            <p>Learn More</p>
          </li>

          <li>
            <img alt="Clear Vision" src={`${baseImageUrl}/perfect-fit-2.webp`} />
            <h4>
              Clear
              <br />
              Vision Blue
            </h4>
            <p>Learn More</p>
          </li>

          <li data-key="traditional">
            <img alt="Traditional Lenses" src={`${baseImageUrl}/perfect-fit-3.webp`} />
            <h4>
              Traditional
              <br />
              Lenses
            </h4>
          </li>
        </ul>

        <ul className="contact-lens-rich-content__perfect-fit__comparison">
          <li className="contact-lens-rich-content__perfect-fit__comparison__item">
            <div className="contact-lens-rich-content__perfect-fit__comparison__item__title">
              <p>Hours of comfort</p>
            </div>

            <div className="contact-lens-rich-content__perfect-fit__comparison__item__value">
              <p>12-16 hrs</p>
              <p>12-16 hrs</p>
              <span data-key="incorrect" />
            </div>
          </li>

          <li className="contact-lens-rich-content__perfect-fit__comparison__item">
            <div className="contact-lens-rich-content__perfect-fit__comparison__item__title">
              <p>UV Protection</p>
            </div>

            <div className="contact-lens-rich-content__perfect-fit__comparison__item__value">
              <span data-key="correct" />
              <span data-key="correct" />
              <span data-key="incorrect" />
            </div>
          </li>

          <li className="contact-lens-rich-content__perfect-fit__comparison__item">
            <div className="contact-lens-rich-content__perfect-fit__comparison__item__title">
              <p>
                High Water
                <br />
                Content
              </p>
            </div>

            <div className="contact-lens-rich-content__perfect-fit__comparison__item__value">
              <span data-key="correct" />
              <span data-key="correct" />
              <span data-key="incorrect" />
            </div>
          </li>

          <li className="contact-lens-rich-content__perfect-fit__comparison__item">
            <div className="contact-lens-rich-content__perfect-fit__comparison__item__title">
              <p>
                Blue Light
                <br />
                Protection
              </p>
            </div>

            <div className="contact-lens-rich-content__perfect-fit__comparison__item__value">
              <span data-key="correct" />
              <span data-key="incorrect" />
              <span data-key="incorrect" />
            </div>
          </li>

          <li className="contact-lens-rich-content__perfect-fit__comparison__item">
            <div className="contact-lens-rich-content__perfect-fit__comparison__item__title">
              <p>Hyaluronic Acid</p>
            </div>

            <div className="contact-lens-rich-content__perfect-fit__comparison__item__value">
              <span data-key="correct" />
              <span data-key="correct" />
              <span data-key="incorrect" />
            </div>
          </li>

          <li className="contact-lens-rich-content__perfect-fit__comparison__item">
            <div className="contact-lens-rich-content__perfect-fit__comparison__item__title">
              <p>
                Premium Quality at
                <br />
                affordable pricing
              </p>
            </div>

            <div className="contact-lens-rich-content__perfect-fit__comparison__item__value">
              <span data-key="correct" />
              <span data-key="correct" />
              <span data-key="incorrect" />
            </div>
          </li>

          <li className="contact-lens-rich-content__perfect-fit__comparison__item">
            <div className="contact-lens-rich-content__perfect-fit__comparison__item__title">
              <p>Thin Lens</p>
            </div>

            <div className="contact-lens-rich-content__perfect-fit__comparison__item__value">
              <span data-key="correct" />
              <span data-key="correct" />
              <span data-key="incorrect" />
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};
